/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum LibModelsEditSource {
    User = 'user',
    MuStreamEdit = 'mu_stream_edit'
}

export function LibModelsEditSourceFromJSON(json: any): LibModelsEditSource {
    return LibModelsEditSourceFromJSONTyped(json, false);
}

export function LibModelsEditSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LibModelsEditSource {
    return json as LibModelsEditSource;
}

export function LibModelsEditSourceToJSON(value?: LibModelsEditSource | null): any {
    return value as any;
}

